import { stageVideoStore } from './store.js';
import { templateStore } from '../../template/index.js';

/**
 * Render video list using EJS templates
 * @param {HTMLElement} container - Container element
 */
export function displayList(container) {
	const videos = stageVideoStore.getVideos();
	const template = templateStore.get('stage/video/item.ejs');
	const emptyTemplate = templateStore.get('stage/video/empty.ejs');
	const listTitleTemplate = templateStore.get('stage/video/list-title.ejs');

	if (!videos.length) {
		// eslint-disable-next-line no-undef
		container.innerHTML = ejs.render(emptyTemplate, {}) || '';
		return;
	}

	let html = '';
	videos.forEach(video => {
		// eslint-disable-next-line no-undef
		html += ejs.render(template, { video });
	});

	// eslint-disable-next-line no-undef
	container.innerHTML = ejs.render(listTitleTemplate, { count: videos.length }) || '';
	container.insertAdjacentHTML('beforeend', html);
}

/**
 * Trigger reload for video list
 */
export function triggerStageVideosReload() {
	document.dispatchEvent(new CustomEvent('stage-videos-reload'));
}
